import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import SearchInput from './SearchInput'
import { MESSAGE, UI } from '../config'
import { searchVehiclesByQuery } from '../extras/utils'

import '../styles/VehicleModelSearch.scss'

export default class VehicleModelSearch extends Component {
  static propTypes = {
    vehicles: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    label: PropTypes.string,
    placeholder: PropTypes.string,
    filterList: PropTypes.bool,
    onQueryChange: PropTypes.func,
    autoFocus: PropTypes.bool,
  }

  static defaultProps = {
    label: '',
    placeholder: UI.UNIFIED_SEARCH_STEP1_PLACEHOLDER,
    filterList: false,
    autoFocus: false,
  }

  state = {
    query: '',
  }

  onQueryChange = (query) => {
    this.setState({ query })

    if (this.props.filterList && typeof this.props.onQueryChange === 'function') {
      this.props.onQueryChange(query)
    }
  }

  onSelectVehicle = (vehicle) => {
    this.setState({ query: '' })
    this.props.onSelect(vehicle)
  }

  getMinCharacters = () => (
    this.props.filterList ? 0 : UI.SEARCH_MIN_CHARACTERS
  )

  shouldShowResults = () => {
    const { filterList } = this.props
    const trimmedQuery = this.state.query.trim()

    return !filterList && trimmedQuery.length >= this.getMinCharacters()
  }

  renderResults() {
    const { vehicles } = this.props
    const trimmedQuery = this.state.query.trim()

    if (!this.shouldShowResults()) return null

    const allResults = searchVehiclesByQuery(vehicles, trimmedQuery)
    const count = allResults.length
    const results = allResults.slice(0, 8)

    return (
      <div className="VehicleModelSearch-panel">
        <p className="VehicleModelSearch-resultsHeader">
          {MESSAGE.SEARCH_RESULTS} ({count})
        </p>
        {count > 0 ? (
          <ul className="VehicleModelSearch-results">
            {results.map(vehicle => (
              <li key={vehicle.id}>
                <button type="button" onClick={() => this.onSelectVehicle(vehicle)}>
                  <span className="VehicleModelSearch-result-title">{vehicle.model}</span>
                  <span className="VehicleModelSearch-result-brand">{vehicle.make}</span>
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <p className="VehicleModelSearch-empty">{UI.NO_RESULTS_FOUND}</p>
        )}
      </div>
    )
  }

  render() {
    const { label, placeholder, autoFocus, filterList } = this.props
    const stepClass = filterList ? 'VehicleModelSearch--step2' : 'VehicleModelSearch--step1'
    const hasResults = this.shouldShowResults()

    return (
      <div className={classNames('VehicleModelSearch', stepClass, hasResults && 'has-results')}>
        {label ? <p className="VehicleModelSearch-label">{label}</p> : null}
        <div className="VehicleModelSearch-field">
          <SearchInput
            variant="unified"
            onChange={this.onQueryChange}
            searchQuery={this.state.query}
            autoFocus={autoFocus}
            placeholder={placeholder}
            minCharacters={this.getMinCharacters()}
          />
          {hasResults ? this.renderResults() : null}
        </div>
      </div>
    )
  }
}
